import React, { Component } from "react";
import { connect } from "react-redux";

import { number, bool, func, shape, arrayOf, node, string } from "prop-types";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import { actions as campaignsActions, selectors as campaignsSelectors } from "reducers/campaigns";

import * as configUtils from "util/config";
import * as i18nUtils from "util/i18n";
import { Mixpanel } from "util/clickstreaming";
import Button from "pages/_components/Button";

import CloseCampaignModal from "pages/campaigns/CloseCampaignModal";
import CampaignHeader from "./CampaignHeader";

class CampaignList extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        idCampaign: number.isRequired,
        clickable: bool.isRequired,
        items: arrayOf(shape({})).isRequired,
        displayModal: bool.isRequired,
        selectedCampaign: number.isRequired,
        children: node.isRequired,
        section: string.isRequired,
    };

    renderImage = (image, url = null) => (
        <img
            src={`data:image/png;base64, ${image.content}`}
            alt="cat"
            onClick={url ? () => this.handleClick() : null}
        />
    );

    handleClick = () => {
        const { idCampaign } = this.props;
        Mixpanel.track("campaign.click", {
            id: idCampaign,
        });
    };

    hideModal = () => {
        const { dispatch } = this.props;
        dispatch(campaignsActions.closeDisplayModal());
    };

    getFittingImage = ([mobileImage, tabletImage, desktopImage]) => {
        if (window.innerWidth < 769) {
            return mobileImage;
        }
        if (window.innerWidth < 993) {
            return tabletImage;
        }
        return desktopImage;
    };

    renderItem = (item) => {
        const { clickable, dispatch, displayModal, selectedCampaign, section, items } = this.props;

        const baseUrl = configUtils.get("client.baseURL");
        const image = this.getFittingImage(item.imageList);

        const linkURL = item.url && item.url.includes(baseUrl) ? item.url.replace(baseUrl, "") : item.url;

        Mixpanel.track_user("campaign.show", {
            id: item.idCampaign,
            name: item.name,
            url: item.url,
            clickable,
        });

        return (
            <>
                <CampaignHeader {...this.props} idCampaign={item.idCampaign} />
                <div className="col-12" key={item.idCampaign}>
                    <CloseCampaignModal
                        dispatch={dispatch}
                        idCampaign={selectedCampaign}
                        isDisplayed={displayModal}
                        closeModal={this.hideModal}
                        section={section}
                        items={items}
                    />
                    {linkURL ? (
                        <Link to={{ pathname: linkURL }} replace target="_blank" rel="noreferrer noopener">
                            {this.renderImage(image, linkURL)}
                        </Link>
                    ) : (
                        this.renderImage(image)
                    )}
                </div>
            </>
        );
    };

    renderList = () => {
        const { items } = this.props;

        const ArrowLeft = (props) => (
            <Button
                {...props}
                image="images/figma/icon/arrow-left-filled.svg"
                bsStyle="btn-rotate"
                aria-label={i18nUtils.get("Anterior")}
            />
        );
        const ArrowRight = (props) => (
            <Button
                {...props}
                image="images/figma/icon/arrow-right-filled.svg"
                bsStyle="btn-rotate"
                aria-label={i18nUtils.get("Siguiente")}
            />
        );

        const settings = {
            draggable: true,
            infinite: false,
            initialSlide: 0,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            ...(items[0].length > 1 && {
                arrows: true,
                dots: true,
                nextArrow: <ArrowRight />,
                prevArrow: <ArrowLeft />,
            }),
            responsive: [
                {
                    breakpoint: 1366,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: 0,
                    },
                },
                {
                    breakpoint: 800,
                    settings: {
                        arrows: false,
                        initialSlide: 0,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        };

        return (
            <div className="slick-slider-wrapper">
                <Slider {...settings}>{items[0].map(this.renderItem)}</Slider>
            </div>
        );
    };

    render() {
        const { children } = this.props;

        return children(this.renderList());
    }
}

const mapStateToProps = (state) => ({
    selectedCampaign: campaignsSelectors.getSelectedCampaign(state),
    displayModal: campaignsSelectors.getDisplayModal(state),
});

export default connect(mapStateToProps)(CampaignList);
